module.exports = __webpack_public_path__ + "static/media/17.3a134a84.jpg";